// removed by extract-text-webpack-plugin
module.exports = {"range":"XQfQl","percentage":"_3nwCF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/search/DiversityPicker.css
// module id = 844
// module chunks = 0